






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex'
// import AccountVue from '../Account.vue';
// import CollapseToggleVue from '../CollapseToggle.vue';

@Component
export default class Navbar extends Vue {
  @Prop() private custome_class?: string;
  @Prop() private burger?: string;
  @Prop() private toggle?: string;
  @Prop() private pageName!: string;

  name = 'تایه';
  profile: any = null;

  components: {
    // 'account': AccountVue,
    // 'toggle': CollapseToggleVue
  }
  computed = {
    ...mapGetters([
      'userType'
    ])
  }
  watch = {
    userType: async (val: Promise<any>) =>  {
      this.profile = await val;
      return val;
    }
  }

  async mounted() {
    this.profile =  await this.$store.getters.userType
    if (this.pageName) this.name = this.pageName;
  }
}

